module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-container",
    class: [_vm.$route.meta.type ? ("jin-" + (_vm.$route.meta.type)) : '', {
      'is-vip-page': _vm.vipLivePage
    }]
  }, [_c('div', {
    staticClass: "jin-box"
  }, [_c('header-new', {
    attrs: {
      "user": _vm.headerUser,
      "show-search": false,
      "show-follow-us": false,
      "mobileShowTabBar": false
    },
    on: {
      "login": function($event) {
        return _vm.onUserAction('login')
      },
      "logout": function($event) {
        return _vm.onUserAction('logout')
      },
      "register": function($event) {
        return _vm.onUserAction('register')
      }
    }
  }, [_c('template', {
    slot: "navCustom"
  }, [_c('RoomNav', {
    on: {
      "show-live-tips": _vm.onRoomNavLiveTips
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "drawerContent"
  }, [_c('RoomNav', {
    on: {
      "show-live-tips": _vm.onRoomNavLiveTips
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "jin-page"
  }, [(_vm.showContent) ? _c('div', {
    staticClass: "tv-wrap tv-wrap-main"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1) : _vm._e()])], 1), _vm._v(" "), _c('footer-new'), _vm._v(" "), (_vm.passwordPopup) ? _c('div', {
    staticClass: "jin-password-popup"
  }, [_c('div', {
    staticClass: "jin-password-popup-content"
  }, [_c('div', {
    staticClass: "jin-password-popup-title"
  }, [_vm._v("请输入密码")]), _vm._v(" "), _c('div', {
    staticClass: "jin-password-popup-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "jin-password-popup-button"
  }, [_c('button', {
    staticClass: "jin-password-popup-button-cancel",
    on: {
      "click": _vm.closePasswordPopup
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "jin-password-popup-button-confirm",
    on: {
      "click": _vm.checkPassword
    }
  }, [_vm._v("确定")])])])]) : _vm._e(), _vm._v(" "), _c('BaseOverlay', {
    attrs: {
      "z-index": 2000
    },
    model: {
      value: (_vm.isOverlayVisible),
      callback: function($$v) {
        _vm.isOverlayVisible = $$v
      },
      expression: "isOverlayVisible"
    }
  }, [_c('div', {
    staticClass: "live-tips-content"
  }, [_c('img', {
    staticClass: "live-tips-content-img",
    attrs: {
      "src": require("../../assets/img/commons/msgbox/tips@2x.png"),
      "alt": "live-tips"
    }
  }), _vm._v(" "), _c('p', [_vm._v("当前节目正在直播，是否继续跳转")]), _vm._v(" "), _c('div', {
    staticClass: "live-tips-content-footer"
  }, [_c('glass-btn', {
    attrs: {
      "type": "default",
      "round": "",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.isOverlayVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('glass-btn', {
    attrs: {
      "type": "primary",
      "round": "",
      "size": "large"
    },
    on: {
      "click": _vm.handleJump
    }
  }, [_vm._v("跳转")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74e51d62","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tv/App.vue
// module id = ti6K
// module chunks = 2 3 4 6 7 8 9